module.exports = __webpack_public_path__ + "750022c66f52d4bcdd5ce63f0bee1dd5.svg";